export default "__VITE_ASSET__Nd4SPvG5__"